import { render } from "./component-egrul-sulpd-name.vue?vue&type=template&id=fb08cc18"
import script from "./component-egrul-sulpd-name.vue?vue&type=script&setup=true&lang=js"
export * from "./component-egrul-sulpd-name.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/counteragents/counteragent-version-card/components/component-egrul-sulpd-name.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fb08cc18"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fb08cc18', __exports__)) {
    api.reload('fb08cc18', __exports__)
  }
  
  module.hot.accept("./component-egrul-sulpd-name.vue?vue&type=template&id=fb08cc18", () => {
    api.rerender('fb08cc18', render)
  })

}


export default __exports__